import { Button, Input, Select, SelectItem } from "@nextui-org/react";
// @ts-expect-error No se puede realizar la instalación del tipado del Datepicker por conflictos en las dependencias.
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "../../../styles/customDatePickerWidth.css";
import { SearchIcon } from "../../../auth/components/SearchIcon";
import { ContractFilters } from "../interfaces/Contracts.interface";
import { ChangeEvent, FormEvent, useState } from "react";
import { ContractStatus } from "../types/Contracts.type";
import ExcelDownload from "../components/ExcelDownload";

interface InputSetProps {
    currentFilters: ContractFilters;
    onSubmit: (filter: ContractFilters) => void;
}

const InputSet:React.FC<InputSetProps> = ({currentFilters, onSubmit}) => {
    const statusList:{value: ContractStatus, label: string}[] = [
        {
            value: "V",
            label: "Vigentes"
        },
        {
            value: "T",
            label: "Terminados"
        },
        {
            value: "C",
            label: "Cancelados"
        }
    ];
    const dateSearch:{value: string, label: string}[] = [
        {
            value: "start_date",
            label: "Inicio"
        },
        {
            value: "end_date",
            label: "Vencimiento"
        }
    ];

    const [formData, setFormData] = useState<ContractFilters>(currentFilters);
    const [inputError, setInputError] = useState(false);

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onSubmit(formData);
    }

    const inputChange = (e: ChangeEvent<HTMLInputElement|HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const dateChange = (date: string, name: string) => {
        setFormData(prev => {
            const form = {
                ...prev,
                [name]: new Date(date)
            }

            // Si la fecha de inicio es mayor al final entonces no permitimos la busqueda.
            setInputError(form.start_date > form.end_date);

            return form;
        });
    }

    return(
        <form onSubmit={handleSubmit} className="flex w-full flex-wrap md:flex-nowrap gap-4 items-center">
            <Input
                name="contract_no"
                size="sm"
                label="No. Contrato/Anexo"
                value={formData.contract_no}
                onChange={inputChange}
            />
            <Input
                name="username"
                size="sm"
                label="Usuario"
                value={formData.username}
                onChange={inputChange}
            />
            <Select
                name="status"
                size="sm"
                label="Estatus"
                className="max-w-xs"
                value={formData.status}
                defaultSelectedKeys={"V"}
                onChange={inputChange}
            >
                {statusList.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                        {item.label}
                    </SelectItem>
                ))}
            </Select>
            <Select
                name="from_start"
                size="sm"
                label="Fecha"
                className="max-w-xs"
                value={formData.from_start}
                defaultSelectedKeys={"all"}
                onChange={inputChange}
            >
                {dateSearch.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                        {item.label}
                    </SelectItem>
                ))}
            </Select>
            <div className="customDatePickerWidth">
                <DatePicker
                    name="start_date"
                    selected={formData.start_date}
                    onChange={(date: string) => dateChange(date, "start_date")}
                    isClearable={true}
                    isRequired
                    dateFormat="yyyy-MM-dd"
                    customInput={<Input isReadOnly isInvalid={inputError} size="sm" label="Desde"/>}
                />
            </div>
            <div className="customDatePickerWidth">
                <DatePicker
                    name="end_date"
                    selected={formData.end_date}
                    onChange={(date: string) => dateChange(date, "end_date")}
                    isClearable={true}
                    isRequired
                    dateFormat="yyyy-MM-dd"
                    customInput={<Input isReadOnly isInvalid={inputError} size="sm" label="Hasta"/>}
                />
            </div>

            <Button
                size="lg"
                color="primary"
                type="submit"
                isDisabled={inputError}
                title="Buscar Contratos"
            >
                <SearchIcon/>
            </Button>
            <ExcelDownload filters={formData}/>
        </form>
    );
}

export default InputSet;

